import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import {
  DEFAULT_ICON_SIZE,
  getButtonClasses,
  type ButtonSize,
  type ButtonVariant,
} from "@/v2-backoffice-client/components/button/button.constants"
import {
  MANUALS,
  type ManualKey,
} from "@/v2-backoffice-client/components/manual/manual.constants"

export type ManualLinkProps = {
  manual: ManualKey
  variant?: ButtonVariant
  size?: ButtonSize
  className?: string
}

// The way into an operator manual from the surface it is about: a link
// dressed as a button (the Button's own classes, so it sits in a page
// header next to Create customer, or in a panel next to Grant license, as
// an equal), outlined so the primary action beside it stays the loudest,
// opening in a new tab because a manual is a reference read beside the
// board, not a page in the app. The manual is also where every pill and
// button is explained; the app carries no legend.
function ManualLink(props: ManualLinkProps) {
  const { manual, variant = "outline", size = "tiny", className } = props
  const { label, url, title, featureCode } = MANUALS[manual]

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(getButtonClasses({ variant, size }), className)}
      title={title}
      data-feature-code={featureCode}
    >
      <Icon src="book-open-reader" size={DEFAULT_ICON_SIZE} />
      {label}
      <Icon src="arrow-up-right-from-square" size={9} className="opacity-70" />
    </a>
  )
}

export default ManualLink
